import {Layout} from "@components/common";
import Riders, {getRiders} from "./index";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {getShopNavigation, redirectTo404Page} from "../index";

export async function getServerSideProps(context: any) {
  try {
    const {locale, query} = context;
    const riders = await getRiders(query?.category, true);
    return {
      props: {
        ...(await serverSideTranslations(locale, ["common", "home"])),
        ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
        riders,
        U19: true,
        locale
      }
    };
  } catch (error) {
    console.error(error)
    return redirectTo404Page();
  }
}
export default Riders
Riders.Layout = Layout
